<script>
import moment from 'moment'
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'

export default {
  components: {},
  mixins: [layout, NavigateMixin],
  emits: ['time-selected'],
  props: {
    timeSlot: {
      type: String,
      default: '',
      required: true,
    },
    selectedDate: {
      type: String,
      default: '',
      required: true,
    },
    isBooked: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      isSelected: this.isBooked,
      localtimeSlot: this.timeSlot.replaceAll(' ', '').toLowerCase(),
      localDate: this.selectedDate,
      isSlotFromInPast: false,
    }
  },
  mounted: function() {
    const now = moment()
      .format('YYYY-MM-DD HH:mm:ss')
      .toString()
    let tempTimeSlot = this.timeSlot
    let timeSlotArr = []
    if (tempTimeSlot.includes('AM')) {
      tempTimeSlot = tempTimeSlot.replace(' AM', ':00')
    } else if (tempTimeSlot.includes('PM')) {
      tempTimeSlot = tempTimeSlot.replace(' PM', ':00')
      timeSlotArr = tempTimeSlot.split(':')
      if (timeSlotArr[0] < 12) {
        const hour = parseInt(timeSlotArr[0]) + 12
        tempTimeSlot = hour + ':' + timeSlotArr[1] + ':00'
      }
    }

    const timeSlotString = this.localDate + ' ' + tempTimeSlot
    const nowString = now
    const selectedTime = moment(timeSlotString)
    const currentTime = moment(nowString)

    if (selectedTime < currentTime) {
      this.isSlotFromInPast = true
    } else {
      this.isSlotFromInPast = false
    }
  },
  methods: {
    toggleSelect() {
      if (this.isSlotFromInPast) return
      if (!this.isSelected) {
        this.isSelected = !this.isSelected
        this.$emit('time-selected', this.timeSlot)
      }
    },
  },
}
</script>

<template>
  <div
    v-if="!isBooked && !isSlotFromInPast"
    :class="
      isSelected
        ? $style.tile_selected
        : isSlotFromInPast
        ? $style.tile_disabled
        : $style.tile
    "
    @click="toggleSelect"
  >
    <p
      :class="
        isSelected
          ? $style.timeText_selected
          : isSlotFromInPast
          ? $style.timeText_disabled
          : $style.timeText
      "
    >
      {{ localtimeSlot }}
    </p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.tile {
  top: 0;
  right: 0%;
  left: 0%;
  height: 40px;
  padding: 3px;
  margin-top: 10px;
  margin-left: 8px;
  cursor: pointer;
  background: #fff;
  border: 2px solid #0476d9;
  border-radius: 6px;
}

.tile_selected {
  top: 0;
  right: 0%;
  left: 0%;
  height: 40px;
  padding: 3px;
  margin-top: 10px;
  margin-left: 8px;
  cursor: pointer;
  background: #0476d9;
  border: 2px solid #0476d9;
  border-radius: 6px;
}

.tile_disabled {
  top: 0;
  right: 0%;
  left: 0%;
  height: 40px;
  padding: 3px;
  margin-top: 10px;
  margin-left: 8px;
  background: #929292;
  border: 2px solid #686868;
  border-radius: 6px;
}

.timeText {
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
  color: #0476d9;
}

.timeText_selected {
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
  color: #fff;
}

.timeText_disabled {
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
  color: white;
}

@media screen and (max-width: 400px) {
  .timeText,
  .timeText_selected {
    font-size: 13px;
  }
}

@media screen and (max-width: 380px) {
  .timeText,
  .timeText_selected {
    font-size: 12px;
  }

  .tile,
  .tile_selected {
    margin-left: 5px;
  }
}
</style>
